import { County } from "../../@types";

export enum CoverageType {
  MAPD = "MEDICARE_ADVANTAGE_PLAN",
  PDP = "PRESCRIPTION_DRUG_PLAN",
  PDPAndMedigap = "MEDICARE_ADVANTAGE_PLAN_AND_MEDIGAP",
  MedigapPolicy = "MEDIGAP_POLICY",
  learnMore = "LEARN_MORE",
}

export enum ErrorType {
  NONE,
  INVALID,
  MISSING,
  API,
}

export interface CoverageSelectorInitialValues {
  coverageYear?: number;
  zipcode?: string;
  fips?: string;
  coverageType?: CoverageType;
}

export interface CoverageSelectorFormValues {
  coverageYear?: number;
  zipcode?: string;
  county?: County;
  coverageType?: CoverageType;
}

export type CoverageSelectorSelectedValues =
  Required<CoverageSelectorFormValues>;
